import React from 'react';
import Meta from '@components/common/Meta';
import Title from '@components/common/Title';
export default function PrivacyPolicyMeta() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    title: "Privacy Policy"
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "description",
    content: "Read the Chicken Kickers Privacy Policy to learn how we collect, use, and protect your personal information."
  }));
}
;